import React, { Component, Fragment } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { change, reduxForm } from 'redux-form';
import { sendEmail } from '../../../../pages/Dashboard/Complaint/complaintActions';
import { closeModal } from '../../modalActions';
import AgentEmailForm from './AgentEmailForm';
import ReceipientEmailForm from './ReceipientEmailForm';

const mapState = (state, ownProps) => ({
  initialValues: {},
  id: ownProps.complaintId,
  user: state.firebase.profile,
  complaint: ownProps.complaint
});

const actions = {
  sendEmail,
  closeModal
};

class EmailModal extends Component {
  state = {
    options: [],
    receipientType: [
      { label: '', value: '' },
      { label: 'Receipient', value: 'receipient' },
      { label: 'Company', value: 'company' }
    ],
    receipient: '',
    html: '',
    target: ''
  };

  renderQuill({ input }) {
    return (
      <ReactQuill
        onChange={(newValue, delta, source) => {
          input.onChange(newValue);
        }}
        onBlur={(range, source, quill) => {
          input.onBlur(quill.getHTML());
        }}
      />
    );
  }

  selectReceipient = input => {
    this.setState({ target: input });

    if (this.state.target === 'company') {
      this.setState({
        options: [
          { label: '', value: '' },
          { label: 'FocalPoint1', value: 'focalpoint1' },
          { label: 'focalPoint2', value: 'focalpoint2' }
        ]
      });
    } else {
      this.props.dispatch(
        change('email', 'receipient', this.props.complaint.complainant.email)
      );
    }
  };

  selectCompanyReceipient = value => {
    this.props.dispatch(change('email', 'receipient', value));
  };

  render() {
    const {
      complaint,

      user
    } = this.props;

    return (
      <Fragment>
        {user.role === 'complainant' ? (
          <ReceipientEmailForm
            complaint={complaint}
            closeModal={this.props.closeModal}
          />
        ) : (
          <AgentEmailForm
            complaint={complaint}
            closeModal={this.props.closeModal}
          />
        )}
      </Fragment>
    );
  }
}

export default compose(
  connect(mapState, actions),
  reduxForm({ form: 'email' })
)(EmailModal);
